module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-vehicle-hardware"
  }, [(_vm.$is('hardware-card')) ? _c('div', {
    staticClass: "card card-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "columns shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-lg',
      "position": 'top'
    }
  }, [_c('vehicle-hardware-action-buttons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "update": _vm.update
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h3', [_vm._v("#VH" + _vm._s(_vm.item.id))]), _c('span', [_vm._v("Manifacturer")]), _c('h3', [_vm._v(_vm._s(_vm._f("manager")(_vm.item.manager)))]), _c('span', [_vm._v("Serial")]), _c('h3', [_vm._v(_vm._s(_vm.item.serial))])])])]) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
    staticClass: "one-look"
  }, [_c('span', [_vm._v("Hardware Serial")]), _c('span', [_vm._v(_vm._s(_vm.item.serial))])]) : _vm._e(), (_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card3', [_c('div', {
    staticClass: "field-vehicle-hardware",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("VH-" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Serial " + _vm._s(_vm.item.serial))])]), _c('div', {
    staticClass: "field-vehicle-serial",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Manager")]), _c('div', {
    staticClass: "field-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("manager")(_vm.item.manager)))])])])])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('span', [_vm._v("Hardware Information")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a450ce6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/VehicleHardware.vue
// module id = 2302
// module chunks = 1